
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M41 31h5v3h-5v-3ZM37 19h3v3h-3v-3ZM32.395 24.599c2.92 6.173 3.022 12.25.227 13.57-2.794 1.322-7.425-2.612-10.345-8.786-2.92-6.173-3.021-12.25-.227-13.57 2.794-1.322 7.426 2.612 10.345 8.786ZM36.194 6l2.745 2.624-6.889 7.204-2.744-2.624L36.194 6Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Polygon 5",attrs:{"d":"m23 13.5-20.5 20L4 37l29.5-2","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 6",attrs:{"d":"M32.87 22.032c1.437 3.038 2.169 6.03 2.208 8.4.04 2.42-.633 3.98-1.742 4.505-1.11.525-2.744.055-4.589-1.511-1.806-1.535-3.655-3.999-5.091-7.037-1.437-3.037-2.169-6.03-2.208-8.4-.04-2.42.633-3.98 1.742-4.505 1.11-.525 2.744-.055 4.589 1.511 1.806 1.535 3.655 3.999 5.091 7.037Z","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 10",attrs:{"d":"m10 36.5 1 4.5 8.5-1 1-4","stroke":"#234652"}}),_c('path',{staticClass:"i-Line 10",attrs:{"stroke":"#234652","d":"m31.604 12.92 3.975-6.19"}}),_c('path',{staticClass:"i-Line 11",attrs:{"stroke":"#234652","d":"m37.422 21.059 4.414-1.531"}}),_c('path',{staticClass:"i-Line 12",attrs:{"stroke":"#234652","d":"m39.521 31.233 5.561.927"}}),_c('path',{staticClass:"i-Vector 6",attrs:{"d":"m12.5 36.5.5 2 4.5-.5.5-2","stroke":"#234652"}})])
          )
        }
      }
    